export default "__VITE_ASSET__BFcTa41X__"